import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_POPUP_SCHEMA = Object.freeze({
  IDENTIFIER: '',
});
const RECORD = generateSchema(TRACKING_POPUP_SCHEMA);
const KEYS: any = generateKeys(TRACKING_POPUP_SCHEMA);

export class PopupTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.popup;
  }

  get properties() {
    return this.toJS();
  }
}
